export default {
  namespaced: true,

  state: {
    kolId: null,
    kolName: null,
    kolChannel: 'wechat',
    wechatCheckedColumns: [
      'history_price',
      'price_newrank',
      'price_ims',
      'avg_likes',
      'fans'
    ],
    weiboCheckedColumns: [
      'history_price',
      'price_newrank',
      'price_ims',
      'avg_likes',
      'fans'
    ],
    wechatSelectedColumns: [
      'history_price',
      'price_newrank',
      'price_ims',
      'avg_likes',
      'fans'
    ],
    weiboSelectedColumns: [
      'history_price',
      'price_newrank',
      'price_ims',
      'avg_likes',
      'fans'
    ]
  },

  mutations: {
    setKolId (state, value) {
      state.kolId = value
    },
    setKolChannel (state, value) {
      state.kolChannel = value
    },
    setKolName (state, value) {
      state.kolName = value
    },
    setWechatCheckedColumn (state, value) {
      state.wechatCheckedColumns = value
    },
    setWeiboCheckedColumn (state, value) {
      state.weiboCheckedColumns = value
    },
    setWechatSelectedColumn (state, value) {
      state.wechatSelectedColumns = value
    },
    setWeiboSelectedColumn (state, value) {
      state.weiboSelectedColumns = value
    }
  }
}
